// extracted by mini-css-extract-plugin
module.exports = {"layout-container":"Layout_layout-container__x19RF","container":"Layout_container__2MXcM","storage":"Layout_storage__3OdUa"};